module.exports = __webpack_public_path__ + "img/icon-ecosystem-light-black.49bae88c.svg";